// base rc-tabs 11.10.1
import Tabs from './Tabs';
import TabPane from './TabPanelList/TabPane';
export { TabPane };
export default Tabs;
